import { useCallback } from 'react';
import axios from 'axios';
import { getBaseUrl } from '../utils/request';

const useFetchNumberCookie = ({
    setNumberCookie
}) => {
    return useCallback(async (authToken) => {
		try {
			const response = await axios.get(getBaseUrl()+"/usr/profile",
				{
					headers: {
						'x-ofb-token': authToken,
					},
				}
			);
			if (response.data.data.mobileNumber) {
				setNumberCookie(response.data.data.mobileNumber);
			}
		} catch (error) {
			console.error("Error fetching number cookie:", error);
		}
	}, [setNumberCookie]);
};

export default useFetchNumberCookie;